import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import BASE_API_URL from "../apis/index"; // adjust import path if needed
import { Chip } from "@mui/material";
// import { useEffect } from "react";
import { useContext } from "react";
import { UserContext } from '../App';

const Header = () => {
  const {user} = useContext(UserContext);
  const navigate = useNavigate();
  const isLoggedIn = user && user.userId; // check if user is logged in

  return (
    <HeaderContainer>
      <div className="container">
        <NavBar>
          <Link to="/">
            <img src="/Images/logo-nt.svg" alt="Logo" width={"150px"} />
          </Link>
          <NavLinks>
            <Link to="/">Home</Link>
            <Link to="https://nutrifytoday.com/what-we-do/" target="_blank">About Us</Link>
            <Link to="/contact-us">Contact Us</Link>
          </NavLinks>

          {isLoggedIn ? (
            <Chip
              avatar={
                <Avatar
                  alt={user.name}
                  src={
                    user.profile_image
                      ? `${BASE_API_URL}/uploads/user_profile_images/${user.profile_image}`
                      : undefined
                  }
                  sx={{ bgcolor: "primary.main" }}
                >
                  {user.name?.charAt(0)}
                </Avatar>
              }
              label={user.name}
              variant="outlined"
              onClick={() => navigate("/dashboard")}
              sx={{
                cursor: "pointer",
                fontWeight: 500,
                color: 'var(--primary-color)',
                "& .MuiAvatar-root": { width: 32, height: 32 },
                paddingRight: "10px"
              }}
            />
          ) : (
            <AuthButtons>
              <Button to="/login">Login</Button>
              <Button to="/register" primary="true">
                Sign up
              </Button>
            </AuthButtons>
          )}
        </NavBar>
      </div>
    </HeaderContainer>
  );
};

export default Header;

// Styled Components
const HeaderContainer = styled.header`
  width: 100%;
  overflow: hidden;
`;

const NavBar = styled.nav`
  display: flex;
  margin: 15px 0px;
  align-items: center;
  justify-content: space-between;
  height: 72px;
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  a {
    color: var(--primary-color);
    text-decoration: none;
    font-weight: 500;
    font-size: 1.08rem;
    transition: color 0.2s;
    &:hover {
      color: var(--secondary-color);
    }
  }
`;

const AuthButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const Button = styled(Link)`
  padding: 8px 20px;
  border-radius: 50px;
  font-size: 1rem;
  border: ${({ primary }) =>
    primary ? "none" : "1.5px solid var(--secondary-color)"};
  background: ${({ primary }) =>
    primary
      ? "linear-gradient(155deg, var(--secondary-color) 0%, var(--primary-color) 100%)"
      : "var(--white-color)"};
  color: ${({ primary }) =>
    primary ? "var(--white-color)" : "var(--secondary-color)"};
  text-decoration: none;
  transition: 0.2s;
  &:hover {
    background: ${({ primary }) =>
    primary
      ? "linear-gradient(225deg, var(--primary-color) 0%, var(--secondary-color) 100%)"
      : "var(--secondaryLight-color)"};
    color: ${({ primary }) =>
    primary ? "var(--white-color)" : "var(--primary-color)"};
  }
`;

// const AvatarWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   cursor: pointer;
// `;
